var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatSquareLineChatLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.81438 10.2359L6.54333 10.6938C6.30174 11.102 5.69824 11.102 5.45665 10.6938L5.1856 10.2359C4.97536 9.88072 4.87024 9.70313 4.7014 9.60492C4.53255 9.50672 4.31996 9.50305 3.89479 9.49573C3.26711 9.48491 2.87344 9.44645 2.54329 9.3097C1.93072 9.05596 1.44404 8.56928 1.1903 7.95671C1 7.49728 1 6.91485 1 5.75V5.25C1 3.61328 1 2.79493 1.3684 2.19375C1.57454 1.85737 1.85736 1.57454 2.19375 1.3684C2.79493 1 3.61328 1 5.25 1H6.75C8.38671 1 9.20507 1 9.80625 1.3684C10.1426 1.57454 10.4255 1.85737 10.6316 2.19375C11 2.79493 11 3.61328 11 5.25V5.75C11 6.91485 11 7.49728 10.8097 7.95671C10.556 8.56928 10.0693 9.05596 9.45671 9.3097C9.12655 9.44645 8.73288 9.48491 8.10519 9.49573C7.68002 9.50305 7.46743 9.50672 7.29858 9.60492C7.12973 9.70313 7.02461 9.88072 6.81438 10.2359ZM4 5.875C3.79289 5.875 3.625 6.04289 3.625 6.25C3.625 6.45711 3.79289 6.625 4 6.625H6.75C6.95711 6.625 7.125 6.45711 7.125 6.25C7.125 6.04289 6.95711 5.875 6.75 5.875H4ZM3.625 4.5C3.625 4.29289 3.79289 4.125 4 4.125H8C8.20711 4.125 8.375 4.29289 8.375 4.5C8.375 4.70711 8.20711 4.875 8 4.875H4C3.79289 4.875 3.625 4.70711 3.625 4.5Z",
    fill: "#7E969F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatSquareLineChatLine);
export default __webpack_public_path__ + "static/media/chat_square_line_chat_line.7c1851cd2d8c759b4f8ac3bf4eaaee31.svg";
export { ForwardRef as ReactComponent };